var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadF(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 346.61,
    height: 468.84,
    viewBox: "0 0 346.61 468.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #414042;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.5,
    x2: 2.5,
    y2: 468.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121,16.59V194.67a544.64,544.64,0,0,1,102.41-94.42A591.82,591.82,0,0,1,359.07,28.54",
    transform: "translate(-13.43 -10.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121,479.38c-1-33.2,1.18-125.82,70.21-217.56,58.08-77.18,133.37-113.71,167.86-128.1",
    transform: "translate(-13.43 -10.62)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadF);
export default __webpack_public_path__ + "static/media/road-F.b881667e7e9f537c6a383a3271bfa88c.svg";
export { ForwardRef as ReactComponent };